import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, LOCAL_STORAGE, StorageService } from 'angular-webstorage-service';


// key that is used to access the data in local storage
const STORAGE_KEY = 'local_todolist';
const TOKEN_KEY = 'local_token';
const USER_KEY = 'local_user';
const CODE_KEY = 'local_Code';

const EMAIL_KEY = 'local_email';
const KEY_COMPANYID = 'local_companyId';
const KEY_COMPANY_NAME = 'local_companyName';

const QBO_VENDOR_KEY = 'local_QboVendor';
const QBO_ACCOUNT_KEY = 'local_QboAccount';
const QBO_ITEM_KEY = 'local_QboItems';
const QBO_SALESTAX_KEY = 'local_QboSalesTax';
const RAH_MASTER_KEY = 'local_rahMaster';
const QBO_CUSTOMER_KEY = 'local_QboCustomer';
const ACCOUNTID = 'local_AccountID';

const QBO_CLASS_KEY = 'local_QboClass';
const ISCLASS_KEY = 'local_QboClass';
const ISJOB_KEY = 'local_QboClass';
const PAGE_NAME = 'local_PageName';


@Injectable({
  providedIn: 'root'
})

@Injectable()
export class StoreService {
  anotherTodolist = [];

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) { }

  public storeOnLocalStorage(taskTitle: string): void {

    //get array of tasks from local storage
    const currentTodoList = this.storage.get(STORAGE_KEY) || [];

    // push new task to array
    currentTodoList.push({
      title: taskTitle,
      isChecked: false
    });

    // insert updated array to local storage
    this.storage.set(STORAGE_KEY, currentTodoList);

    console.log(this.storage.get(STORAGE_KEY) || 'LocaL storage is empty');
  }

  public storeToken(token: string): void {
    this.storage.set(TOKEN_KEY, token);
    console.log(this.storage.get(TOKEN_KEY) || 'LocaL storage is empty');
  }

  public storeCode(code: string): void {
    this.storage.set(CODE_KEY, code);
    console.log(this.storage.get(CODE_KEY) || 'LocaL storage is empty');
  }

  public storeUserName(userName: string): void {
    this.storage.set(USER_KEY, userName);

  }

  public storeAccountID(accountID: number): void {
    this.storage.set(ACCOUNTID, accountID);

  }


  public fetchAccountID(): String {
    return this.storage.get(ACCOUNTID)
  }

  public fetchToken(): String {
    return this.storage.get(TOKEN_KEY)
  }


  public fetchUserName(): String {
    return this.storage.get(USER_KEY)
  }

  public storeEmail(email: string): void {
    this.storage.set(EMAIL_KEY, email);
    console.log(this.storage.get(EMAIL_KEY) || 'LocaL storage is empty');
  }

  public fetchEmail(): String {
    return this.storage.get(EMAIL_KEY)
  }

  public storeIsClass(email: boolean): void {
    this.storage.set(ISCLASS_KEY, email);
    console.log(this.storage.get(ISCLASS_KEY) || 'LocaL storage is empty');
  }

  public storeSyncCustomer(syncCustomer: boolean): void {
    this.storage.set('syncCustomer', syncCustomer);
    console.log(this.storage.get('syncCustomer') || 'syncCustomer is empty');
  }

  public fetchSyncCustomer(): boolean {
    console.log(this.storage.get('syncCustomer') || 'syncCustomer is empty');
    return this.storage.get('syncCustomer')
  }

  public storeSyncAllCustomer(syncCustomer: any): void {
    this.storage.set('Q_AllCustomer', syncCustomer);
    console.log(this.storage.get('Q_AllCustomer') || 'syncCustomer is empty');
  }

  public fetchSyncAllCustomer(): any {
    console.log(this.storage.get('Q_AllCustomer') || 'syncCustomer is empty');
    return this.storage.get('Q_AllCustomer')
  }

  public fetchIsClass(): boolean {
    return this.storage.get(ISCLASS_KEY)
  }

  public storeIsJob(email: boolean): void {
    this.storage.set(ISJOB_KEY, email);
    console.log(this.storage.get(ISJOB_KEY) || 'LocaL storage is empty');
  }

  public fetchIsJob(): boolean {
    return this.storage.get(ISJOB_KEY)
  }

  public storeQboConnectID(value: string): void {
    this.storage.set(KEY_COMPANYID, value);
    console.log(this.storage.get(KEY_COMPANYID) || 'LocaL storage is empty');
  }

  public fetchQboConnectID(): String {
    return this.storage.get(KEY_COMPANYID)
  }

  public storeCompanyName(value: string): void {
    this.storage.set(KEY_COMPANY_NAME, value);
    console.log(this.storage.get(KEY_COMPANY_NAME) || 'LocaL storage is empty');
  }

  public fetchCompanyName(): String {
    return this.storage.get(KEY_COMPANY_NAME)
  }



  public storeQboVendors(data: any): void {
    this.storage.set(QBO_VENDOR_KEY, data);
    console.log(this.storage.get(QBO_VENDOR_KEY) || 'LocaL storage is empty');
  }

  public fetchQboVendors(): any {
    return this.storage.get(QBO_VENDOR_KEY)
  }

  public storeQboClass(data: any): void {
    this.storage.set(QBO_CLASS_KEY, data);
    console.log(this.storage.get(QBO_CLASS_KEY) || 'LocaL storage is empty');
  }

  public fetchQboClass(): any {
    return this.storage.get(QBO_CLASS_KEY)
  }

  public storeQboAccount(data: any): void {
    this.storage.set(QBO_ACCOUNT_KEY, data);
    console.log(this.storage.get(QBO_ACCOUNT_KEY) || 'LocaL storage is empty');
  }

  public fetchQboAccount(): any {
    return this.storage.get(QBO_ACCOUNT_KEY)
  }

  public storeQboItem(data: any): void {
    this.storage.set(QBO_ITEM_KEY, data);
    console.log(this.storage.get(QBO_ITEM_KEY) || 'LocaL storage is empty');
  }

  public fetchQboItem(): any {
    return this.storage.get(QBO_ITEM_KEY);
  }

  public storeQboSalesTax(data: any): void {
    this.storage.set(QBO_SALESTAX_KEY, data);
    console.log(this.storage.get(QBO_SALESTAX_KEY) || 'LocaL storage is empty');
  }

  public fetchQboSalesTax(): any {
    return this.storage.get(QBO_SALESTAX_KEY);
  }

  public storeQboCustomers(data: any): void {
    this.storage.set(QBO_CUSTOMER_KEY, data);
    console.log(this.storage.get(QBO_CUSTOMER_KEY) || 'LocaL storage is empty');
  }

  public fetchQboCustomers(): any {
    return this.storage.get(QBO_CUSTOMER_KEY)
  }

  public storeAccountRahMaster(data: any): void {
    this.storage.set(RAH_MASTER_KEY, data);
    console.log(this.storage.get(RAH_MASTER_KEY) || 'LocaL storage is empty');
  }


  public fetchAccountRahMaster(): any {
    return this.storage.get(RAH_MASTER_KEY)
  }



  public storePageName(data: any): void {
    this.storage.set(PAGE_NAME, data);
   
  }

  public fetchPageName(): any {
    return this.storage.get(PAGE_NAME)
  }
  

  public clearAll(): any {
    this.storage.set(QBO_ACCOUNT_KEY, null);
  
    this.storage.set(QBO_CUSTOMER_KEY, null);
    this.storage.set(QBO_VENDOR_KEY, null);
    this.storage.set(QBO_CLASS_KEY, null);
    this.storage.set(KEY_COMPANYID, null);
    this.storage.set(EMAIL_KEY, null);
    this.storage.set(TOKEN_KEY, null);
    this.storage.set(KEY_COMPANY_NAME, null);
    this.storage.set(USER_KEY, null);
    this.storage.set(ISCLASS_KEY, false);
    this.storage.set(ISJOB_KEY, false);
    this.storage.set(RAH_MASTER_KEY, null);
    this.storage.set(QBO_ITEM_KEY, null);
    this.storage.set(QBO_SALESTAX_KEY, null);
    this.storage.set(PAGE_NAME, null);
    
  }

}